import { createContext } from 'react';
import { useEffect, useState, useContext } from 'react';
import { HTTP } from '../../lib/http';
import PropTypes from 'prop-types';

export const PERMISSIONS = {
  map: 'web.map',
  GetAnimalsLocation: 'webapi.Animal',
  GetHostileLocation: 'webapi.Hostile',
  GetPlayersOnline: 'webapi.GetPlayersOnline',
  GetPlayersLocation: 'webapi.GetPlayersLocation',
  GetPlayerInventory: 'webapi.GetPlayerInventory',
  GetLandClaims: 'webapi.GetLandClaims',
  GetStats: 'webapi.ServerStats',
  ExecuteConsoleCommand: 'webapi.Command',
  GetLog: 'webapi.Log',
  GetWebUIUpdates: 'webapi.WebUIUpdates',
  GetServerInfo: 'webapi.ServerInfo',
  GetPlayerList: 'webapi.GetPlayerList',
  GetAllowedCommands: 'webapi.GetAllowedCommands',
  GetPlayerInventories: 'webapi.GetPlayerInventories',
  viewallclaims: 'webapi.viewallclaims',
  viewallplayers: 'webapi.viewallplayers',
  log: 'webevent.log',
  WebMods: 'webapi.WebMods',
};

async function getStatus() {
  return HTTP.get('/userstatus');
}

export const AuthContext = createContext({ status: { loggedin: false } });

export function AuthProvider({ children }) {
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);

  function checkPermission(requestedPermission) {
    const module = status.permissions.find((p) => p.module.toLowerCase() === requestedPermission.toLowerCase());
    if (!module) return false;

    return module.allowed;
  }

  useEffect(() => {
    async function fetchStatus() {
      const status = await getStatus();
      setStatus(status);
      setPermissions(status.permissions);
      setLoading(false);
    }

    fetchStatus();
  }, []);

  if (loading) return null;

  return <AuthContext.Provider value={{ status, loading, permissions, checkPermission }}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useAuth() {
  return useContext(AuthContext);
}
